module.exports = __webpack_public_path__ + "static/media/main-sub5.a0d6ee1a.svg";